import React from 'react';
import emptyDashboardImage from '../images/empty-dashboard-image.png';

function EmptyState({
    message = 'No data found',
    submessage = 'Create some records to view them here',
}) {
    return (
        <div className="h-full pt-10">
            <div className="flex flex-col gap-2 items-center justify-center h-full w-full">
                <img src={emptyDashboardImage} alt="No participants" />
                <h1 className="font-semibold text-xl text-primary">
                    {message}
                </h1>
                <p className="text-secondary font-medium">{submessage}</p>
            </div>
        </div>
    );
}

export default EmptyState;
